import type { ReadonlyVec3 } from 'gl-matrix';
import { seriesInstanceUidOf } from '~/domain/dicom/uids';
import type { Environment } from '~/engine/data/Environment';
import type { DatasetEnvironmentRegistry } from '~/engine/scene/DatasetEnvironmentRegistry';
import type { ViewManager } from '~/engine/view/ViewManager';
import { focusGridPoint } from './focusGridPoint';
import { petPointInRowFrame } from './petImageOf';

/**
 * Frames every tile of a row on a point (mm, PET frame) of the PET of the
 * pair `environment` draws (an Environment's own, or a tile's own fusion),
 * carried into the row's frame at the call so an edited registration counts.
 * @returns Whether a tile was framed.
 */
export function focusRowOnPetPoint(
    registry: DatasetEnvironmentRegistry,
    viewManager: ViewManager | null,
    environment: Pick<Environment, 'image' | 'secondaryImage' | 'registration'>,
    pointInPetFrame: ReadonlyVec3
): boolean {
    const point = petPointInRowFrame(environment, pointInPetFrame);
    if (!point) {
        return false;
    }
    return focusGridPoint(
        registry,
        viewManager,
        seriesInstanceUidOf(environment.image?.parent.seriesUid),
        point
    );
}
